<template>
  <div class="container">
    <div class="white-card">
      <div class="loader absolute" v-if="loading"></div>
      <h3>Mes Abonnements</h3>
      <div class="table-responsive">
        <table class="table table-striped mt-3">
          <thead>
          <tr>
            <th>Type</th>
            <th>Offre</th>
            <th>Debut</th>
            <th>Fin</th>
          </tr>
          </thead>
          <tbody v-if="!loading">
          <tr v-for="(subscription,i) in subscriptions" :key="i">
            <td>{{ subscription.type === 'tutoring' ? 'Soutien Scolaire' : 'Langue' }}</td>
            <td>{{ subscription.plan }}</td>
            <td>{{ subscription.created_at | date }}</td>
            <td>{{ subscription.ends_at | date }}</td>
          </tr>
          <tr v-if="!subscriptions.length">
            <td class="text-center" colspan="4">Aucun abonnement trouvé</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Subscriptions",
  data() {
    return {
      subscriptions: [],
      loading: false
    }
  },
  created() {
    this.loading = true
    this.$axios.get('/subscriptions', {baseURL: this.$axios.defaults.baseApiUrl})
      .then(({data}) => {
        this.subscriptions = data
      })
      .finally(() => this.loading = false)
  }
}
</script>

<style scoped>

</style>
